import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { RoleBasedRedirectGuard } from './guards/role-based-redirect.guard';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { LayoutComponent } from './layouts/layout/layout.component';
import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [RoleBasedRedirectGuard],
    component: DashboardLayoutComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () =>
      import('./pages/authentication/authentication.route').then(
        (mod) => mod.AUTHENTICATION_ROUTES,
      ),
  },
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/dashboard/dashboard.route').then(
        (mod) => mod.DASHBOARD_ROUTES,
      ),
  },
  {
    path: 'public',
    component: PublicLayoutComponent,
    loadChildren: () =>
      import('./pages/public/public.route').then((mod) => mod.PUBLIC_ROUTES),
  },
  {
    path: 'auto-parts',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/auto-parts/auto-part.route').then(
        (mod) => mod.AUTO_PART_ROUTES,
      ),
  },
  {
    path: 'vehicles',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/vehicles/vehicle.route').then((mod) => mod.VEHICLE_ROUTE),
  },
  {
    path: 'utilities',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/utilities/utilities.route').then(
        (mod) => mod.UTILITIES_ROUTE,
      ),
  },
  {
    path: 'reports',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/reports/reports.route').then((mod) => mod.REPORTS_ROUTE),
  },
  {
    path: 'containers',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/containers/containers.route').then(
        (mod) => mod.CONTAINERS_ROUTE,
      ),
  },
  {
    path: 'batch-upload',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/batch-upload/batch-upload.route').then(
        (mod) => mod.BATCH_UPLOAD_ROUTE,
      ),
  },
];
